export enum UnregisteredSubmissionStatus {
    Pending = 1,
    Rejected = 2,
    Approved = 3,
    ApprovedPendingActivation = 4,
    Success = 5
}
